import {computed, onUnmounted, ref, watch} from '@vue/composition-api'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import storeModule from "./storeModule";
import {useToast} from 'vue-toastification/composition'
import {FieldType, FormConfig} from '../common/index.d.ts'

export default function useUsersList(formConfig) {
    const toast = useToast()

    let processError = (error) => {
        try {
            if (error.response.data) {
                toast({
                    component: ToastificationContent,
                    position: 'bottom-right',
                    props: {
                        title: error.response.data.error.message,
                        icon: 'XIcon',
                        variant: 'danger',
                    },
                })
            }
        } catch (e) {
            toast({
                component: ToastificationContent,
                position: 'bottom-right',
                props: {
                    title: "process failed",
                    icon: 'XIcon',
                    variant: 'danger',
                },
            })
        }
    }
    const tableData = ref(null)
    const tableColumns = []
    const detectValue = (value) => {
        if (value == null) {
            return ""
        }
        //    console.log(value)
        if (value.title) {
            return value.title
        }
        if (value.name) {
            return value.name
        }
        return value.id
    }

    formConfig.configs.forEach(f => {
        if (!f.hideInList) {
            if (FieldType.SELECT == f.type) {
                let mf = (value) => {
                    return detectValue(value);
                }
                tableColumns.push({
                    key: f.name.replace("_id", ""),
                    label: f.label,
                    sortable: f.sortable,
                    formatter: mf
                });
            }
            if (FieldType.PASSWORD == f.type) {
                let mf = (value) => {
                    return "*******";
                }
                tableColumns.push({key: f.name, label: f.label, sortable: f.sortable, formatter: mf});
            } else if (FieldType.MULTIPLE == f.type) {
                let mf = (value) => {
                    if (value == null) {
                        return ""
                    }
                    let res = "";
                    for (let i = 0; i < value.length; i++) {
                        res = res + detectValue(value[i]) + " "
                    }
                    return res
                }
                if (f.name.endsWith("y_ids")) {
                    tableColumns.push({
                        key: f.name.replace("y_ids", "ies"),
                        label: f.label,
                        sortable: true,
                        formatter: mf
                    });
                } else {
                    tableColumns.push({
                        key: f.name.replace("_ids", "s"),
                        label: f.label,
                        sortable: true,
                        formatter: mf
                    });
                }

            } else {
                tableColumns.push({key: f.name, label: f.label, sortable: f.sortable});
            }
        }
    })


    //tableColumns.push({key: 'actions'})

    const perPage = ref(10)
    const totalUsers = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)


    const dataMeta = computed(() => {
        const localItemsCount = tableData.value ? tableData.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalUsers.value,
        }
    })

    const refetchData = () => {
        tableData.value.refresh()
    }
    const filters = [];
    const fetchData = (ctx, callback) => {
        const action = `app-${formConfig.entity}/search${formConfig.entity}`;

        if (searchQuery != "") {
            console.log("should add " + searchQuery.value)
        }

        try {
            store
                .dispatch(action, {
                    'page_size': perPage.value,
                    'page_no': currentPage.value,
                    'order_by': sortBy.value,
                    'order': (isSortDirDesc.value) ? "desc" : "asc",
                    'filter': formConfig.toFilterStr(searchQuery.value),
                })
                .then(response => {
                    const {data, meta} = response.data
                    console.log(data);
                    callback(data)
                    totalUsers.value = meta.pagination.total_results
                })
                .catch((e) => {
                    // console.log(e);
                    processError(e)
                    // toast({
                    //     component: ToastificationContent,
                    //     props: {
                    //         title: `Error fetching ${formConfig.entity} list`,
                    //         icon: 'AlertTriangleIcon',
                    //         variant: 'danger',
                    //     },
                    // })
                })
        } catch (e) {
            console.log(e);
        }

    }

    let USER_APP_STORE_MODULE_NAME = `app-${formConfig.entity}`
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule(formConfig))
    onUnmounted(() => {
        if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })


    let res = {
        fetchData,
        tableColumns,
        perPage,
        currentPage,
        totalUsers,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        tableData,
        refetchData,
    }

    if (formConfig.filters) {
        formConfig.filters.forEach(filter => {
            filters.push(filter.value)
        })
    }

    watch([currentPage, perPage, searchQuery, ...filters], () => {
        refetchData()
    })
    return res;
}
